.OutputField {
  white-space: nowrap;
  flex-direction: row-reverse;
}
